import { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

export interface MessageProps {
  readonly children: React.ReactNode;
  readonly color?: string;
  readonly sx?: SxProps<Theme>;
}

export const Message: React.FC<MessageProps> = (props: MessageProps): React.ReactElement => {
  const { children, color = 'custom.LightGray', sx } = props;

  return (
    <Typography
      variant="body2"
      color={color}
      sx={[styles.message, ...(Array.isArray(sx) ? sx : [sx])]}>
      {children}
    </Typography>
  );
};

const styles: Record<string, SystemStyleObject> = {
  message: {
    textAlign: 'center',
  },
};
